import { Injectable, inject } from '@angular/core'
import { firstValueFrom } from 'rxjs'

import { Hunt } from '@cyborg-monorepo/hunter/common'

import { HuntAPIService } from '../api/hunt-api.service'

@Injectable({ providedIn: 'root' })
export class HuntDatabaseService {
  private readonly api = inject(HuntAPIService)

  /**
   * Load a hunt from the api
   */
  async getHunt(id: string): Promise<Hunt | undefined> {
    try {
      const apiHunt = await firstValueFrom(this.api.getHuntById(id))

      if (apiHunt) {
        return apiHunt
      }

      return undefined
    } catch (error) {
      console.error('HuntDatabase.getHunt', error)
      return undefined
    }
  }

  /**
   * Submit a hunt to the API and persist the result.
   */
  async submitHunt(hunt: Hunt): Promise<Hunt | undefined> {
    const saved = await firstValueFrom(this.api.updateHunt(hunt.id, hunt))
    return saved
  }

  /**
   * Best-effort submit for the `beforeunload` path. Fire-and-forget --
   * there is nothing meaningful to await once the page is unloading.
   */
  submitHuntBeacon(hunt: Hunt): void {
    this.api.updateHuntBeacon(hunt.id, hunt)
  }
}
